export const useToaster = () => {
  const toasts = useState<Toast[]>('toaster-store', () => [])

  const toaster = useToasterIsolated(toasts)

  return {
    ...toaster,
    toasts,
  }
}
